/* no-class-assign */
import React from 'react';
import { Carousel, Button, Modal } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import './LineTest.scss';
import PageHeader from '../PageHeader/PageHeader';
import Loader from '../Loader/Loader';
import ontImg from './ont_diagram_small.svg';

class LineTest extends React.Component {

  constructor() {
    super();
    this.state = { showModal: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  open(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  render() {
    return (
      <main>
        <PageHeader title={'Check Broadband Connection'} />
        <div className="container">
          <div className="test-container">
            <Carousel interval={1500} controls={false} indicators={false} wrap={false} slide>
              <Carousel.Item>
                <Carousel.Caption>
                  <h3>Checking your ONT Status</h3>
                </Carousel.Caption>
                <div className="test-step-item">
                  <Loader height="130" colour="#fb6413" />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <Carousel.Caption>
                  <h3>Checking your RGW Bandwidth</h3>
                </Carousel.Caption>
                <div className="test-step-item">
                  <Loader height="130" colour="#bbb" />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="test-step-item">
                  <h3>There seems to be a problem with the fibre connection to your address</h3>
                  <p>
                    The fibre box (what we in the bizz like to call an &#34;ONT&#34;) at your place doesn&#39;t seem to
                    be powered on. Please check that it is plugged in and switched on at the wall. You want to see a
                    solid green power light on the ONT.&nbsp;
                    <a
                      href="/"
                      onClick={this.open}
                    >
                      Not sure what we&#39;re talking about? Click here for more info
                    </a>. Once the ONT shows a solid green power light, click &quot;Diagnose Again&quot;.
                  </p>

                  <Modal dialogClassName="skinny-modal" show={this.state.showModal} onHide={this.close}>
                    <Modal.Header className="automation-selling-point-modal-header" closeButton>
                      <h4>What is an ONT?</h4>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="skinny-modal-text automation-selling-point-text">
                        You can think of the ONT like the fibre modem, or fibre box. It converts the fibre signal to
                        one your Skinny modem can use, and is what you&#34;ll plug your Skinny modem into.
                        <div className="centre">
                          <img src={ontImg} alt="ONT" />
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>

                  <Button onClick={() => window.location.reload()}>
                    Diagnose Again
                  </Button>
                  <div className="account-action-tile-text centre">
                    If you are still experiencing problems after completing the above steps, please
                    &quot;Submit Case&quot; to submit a case to our help desk.
                  </div>
                  <p>
                    <Button
                      className="btn btn-default btn-secondary"
                      onClick={() => browserHistory.push('/submit-case')}
                    >
                      Submit Case
                    </Button>
                  </p>
                  <Button onClick={() => browserHistory.push('/dashboard')}>Done</Button>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </main>
    );
  }
}

export default LineTest;



/** WEBPACK FOOTER **
 ** ./src/components/LineTest/LineTest.js
 **/